// 5.32.0 Calendar: time helpers. Everything is shown in America/Chicago whatever the PC's own zone is.
// The server sends and takes Chicago WALL strings: 'YYYY-MM-DD' (all-day) or 'YYYY-MM-DDTHH:MM:SS'.
// FullCalendar runs with timeZone="UTC" and gets those strings as-is, so a Date's UTC fields ARE the Chicago wall
// clock ("UTC-coded"). Nothing here uses the browser's local zone.

export const CHICAGO = 'America/Chicago';

// Chicago wall clock right now, 'YYYY-MM-DDTHH:MM:SS'.
export function chicagoNowWall(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: CHICAGO, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
  }).formatToParts(now).reduce((a, p) => { a[p.type] = p.value; return a; }, {});
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`;
}

// FullCalendar's `now` (UTC-coded Chicago wall clock).
export const fcNow = () => new Date(chicagoNowWall() + 'Z');

// A UTC-coded Date from FullCalendar -> Chicago wall string.
export const dateToWall = (d) => d.toISOString().slice(0, 19);

export const wallDate = (s) => (s || '').slice(0, 10);
export const wallTime = (s) => ((s || '').length > 10 ? s.slice(11, 16) : '');

export function addDays(dateStr, n) {
  const d = new Date(`${dateStr}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

// Minutes between two wall strings (both timed).
export function wallDiffMinutes(a, b) {
  return Math.round((new Date(b + 'Z') - new Date(a + 'Z')) / 60000);
}

export function addMinutesWall(s, mins) {
  const d = new Date(s + 'Z');
  d.setUTCMinutes(d.getUTCMinutes() + mins);
  return d.toISOString().slice(0, 19);
}

const fmtDay = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' });
const fmtTime = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', hour: 'numeric', minute: '2-digit' });

// "Thu, Oct 30, 9:00 AM – 10:00 AM" / "Thu, Oct 30 (all day)" / multi-day ranges.
export function formatRange(start, end, allDay) {
  if (!start) return '';
  const s = new Date((start.length === 10 ? `${start}T00:00:00` : start) + 'Z');
  if (allDay) {
    const lastDay = end ? addDays(wallDate(end), -1) : wallDate(start);
    if (!end || lastDay <= wallDate(start)) return `${fmtDay.format(s)} (all day)`;
    return `${fmtDay.format(s)} – ${fmtDay.format(new Date(`${lastDay}T00:00:00Z`))} (all day)`;
  }
  const e = end ? new Date(end + 'Z') : s;
  if (wallDate(start) === wallDate(end || start)) return `${fmtDay.format(s)}, ${fmtTime.format(s)} – ${fmtTime.format(e)}`;
  return `${fmtDay.format(s)}, ${fmtTime.format(s)} – ${fmtDay.format(e)}, ${fmtTime.format(e)}`;
}

export function todayWall() {
  return chicagoNowWall().slice(0, 10);
}
